export const instances = {
  numen: {
    title: 'Numen: NumenExpress',
    customerId: '',
    login: {
      navBarBG: 'numen-nav-bar',
      logo: '../../../../assets/img/NumenLogo.png'
    },
    showMOP: true,
    navBar: {
      logoClass: 'col-1',
      motdClass: 'col-9'
    }
  },
  athome: {
    title: 'Athome: AthomeExpress',
    customerId: 'CL1834',
    login: {
      navBarBG: 'athome-nav-bar',
      logo: '../../../../assets/img/logo_Athome.jpg'
    },
    showMOP: false,
    navBar: {
      logoClass: 'col-1',
      motdClass: 'col-10'
    }
  }
};
